import { req } from "features/Assets/redux/embeddedVideo/embeddedVideoSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { AppPageWrapper } from "../../../Application/layout";
import { BackTitle } from "../../../Application/layout/BackTitle/BackTitle";
import { FetchingLayout } from "../../../Application/layout/FetchingLayout/FetchingLayout";
import { ErrorType, HttpErrorView } from "../../../Application/layout/HttpErrorView/HttpErrorView";
import { SendPageView } from "../../../Application/services/realTimeNotification/googleAnalytics";
import {
  hasAccessSelector,
  selectEmbeddedVideo,
  selectEmbeddedVideoError,
  selectEmbeddedVideoStatus,
} from "../../redux/embeddedVideo/embeddedVideoSelectors";
import { EmbeddedVideoDetails } from "./EmbeddedVideoDetails";
import styles from "./EmbeddedVideoDetailsPage.module.scss";
import { EmbeddedVideoPlayer } from "./EmbeddedVideoPlayer";

export const EmbeddedVideoDetailsPage = () => {
  const { embeddedVideoId } = useParams();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const embeddedVideo = useSelector(selectEmbeddedVideo);
  const hasAccess = useSelector(hasAccessSelector);
  const status = useSelector(selectEmbeddedVideoStatus);
  const errorMessage = useSelector(selectEmbeddedVideoError);

  useEffect(() => {
    if (embeddedVideo?.title) {
      document.title = embeddedVideo.title;
      SendPageView();
    }
  }, [embeddedVideo]);

  useEffect(() => {
    if (embeddedVideoId) {
      dispatch(req({ id: Number(embeddedVideoId) }));
    }
  }, [dispatch, embeddedVideoId]);

  return (
    <AppPageWrapper>
      <FetchingLayout status={status} errorMessage={errorMessage}>
        <div className={styles.root}>
          {hasAccess && embeddedVideo ? (
            <>
              <div className={styles.headerSpacing}>
                <BackTitle to={"/discover"} state={{ prevPage: state }} title={embeddedVideo.title} />
              </div>
              <div className={styles.content}>
                <EmbeddedVideoPlayer
                  source={embeddedVideo.videoSourceId}
                  videoUrl={embeddedVideo.videoUrl}
                  embeddedVideoId={Number(embeddedVideoId)}
                />
              </div>
              <EmbeddedVideoDetails title={embeddedVideo.title} description={embeddedVideo.description ?? ""} />
            </>
          ) : (
            <HttpErrorView code={ErrorType.Forbidden} back />
          )}
        </div>
      </FetchingLayout>
    </AppPageWrapper>
  );
};
